// removed by extract-text-webpack-plugin
module.exports = {"button":"_2xxsb0hR03utV67CzF6LXg","formWrapper":"_4j31r0iGl_GLl3IVXQuKV","icon":"_3digptjJFHz0zrAbXnV5Dn","buttonTypeFlat":"_29z5ea5lYXvBKm2KEHtfKi","buttonTypeRaised":"_1UG708uQ7jCfvSiYUcqt3e","buttonTypeMinimal":"F-RnWuU-icNbtgbg1_SbO","buttonThemeDefault":"_1MElpxhOgiTz5fsAU7kUtD","buttonThemePrimary":"_3xsrqs1QBv6-yoNYXAEKfe","buttonThemeInfo":"_1MGET5BTMUZ4PmJfao3dc0","buttonThemeSuccess":"_3sZGaa2_t-68ijmi0kC_eA","buttonThemeWarning":"-dxqQSODlZIvc_Rn905Ya","buttonThemeDanger":"_2VDUyrHjMzFSKY7cmVPhD0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/00-atoms/buttons/button.scss
// module id = 63
// module chunks = 0